import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../../typography'
// import Image from '../../image'

import { useBreakpoint } from '../../../../hooks/breakpoint'

const Header = ({ title, titleHighlightedText, text, image, ...attrs }) => {
  const breakpoint = useBreakpoint()

  title = title.replace(titleHighlightedText, '')

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-8',
      'pb-10',
      'md:pt-12',
      'md:pb-16',
      'md:bg-white'
    ]
  )

  return <section {...attrs}>
    <div
      className={'absolute top-0 left-0 w-full bg-green-50'}
      style={{
        height: `calc( 100% - ${breakpoint.mdAndUp ? '6rem' : '4rem'} )`
      }} />
    <div
      className={'absolute bottom-0 bg-green-50'}
      style={{
        borderRadius: '100%',
        left: '-5vw',
        width: '110vw',
        height: breakpoint.mdAndUp ? '12rem' : '8rem'
      }} />
    <div
      className={
        classNames([
          breakpoint.mdAndUp ? '' : 'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'flex-wrap',
            'items-center',
            '-mx-4'
          ])
        }
        style={
          {
            minHeight: '25rem'
          }
        }
      >
        <div
          className={
            classNames([
              'relative',
              'px-4',
              'pb-6',
              'pt-12',
              'md:pb-12',
              'md:pt-24',
              'flex',
              'flex-col',
              'justify-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%'
          }}>
          <Typography
            weight={'black'}
            size={breakpoint.mdAndUp ? 'eight' : 'six'}
            className={'text-red-500 mb-4'}>
            {title}{' '}
            <Typography
              tag={'span'}
              weight={'black'}
              size={breakpoint.mdAndUp ? 'eight' : 'six'}
              className={'text-green-500'}>
              {titleHighlightedText}
            </Typography>
          </Typography>
          <Typography
            size={breakpoint.mdAndUp ? 'three' : 'two'}
            className={'text-green-600 mb-4'}>
            {text}
          </Typography>
        </div>
        <div
          className={
            classNames([
              breakpoint.mdAndUp ? 'absolute' : '',
              breakpoint.mdAndUp ? 'top-0' : '',
              breakpoint.mdAndUp ? 'bottom-0' : '',
              breakpoint.mdAndUp ? 'left-1/2' : '',
              breakpoint.mdAndUp ? 'right-0' : '',
              'flex',
              'flex-col',
              'justify-center',
              'items-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%',
            height: breakpoint.mdAndUp ? '100%' : '18rem'
          }}>
          {
            (image && image.meta)
              ? <div
                className={
                  classNames([
                    'bg-cover',
                    'bg-top',
                    'h-full',
                    'w-full'
                  ])
                }
                style={{
                  borderRadius: breakpoint.mdAndUp ? '7.5rem 0 0 0' : '0',
                  backgroundImage: `url('${image.meta.downloadUrl}')`
                }}>
              </div>
              : null
          }
        </div>
      </div>
    </div>
  </section >
}

Header.propTypes = {
  title: PropTypes.string,
  titleHighlightedText: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.object
}
export default Header
